export default "__VITE_ASSET__qXwEMU_6__"